import { useMantineTheme } from '@mantine/core';
import type {
	SecodaAIProposalOut,
	SuggestGlossaryArg,
} from '@repo/api-codegen';
import { IconEmoji } from '@repo/common/components/IconEmoji/IconEmoji';
import type { IBaseModel } from '@repo/common/models/baseModel';
import { useMemo, type MouseEvent } from 'react';
import { SuggestionItemTable } from './SuggestionItemTable';

type GlossarySuggestionWithBaseModel = SuggestGlossaryArg & IBaseModel;

export interface GlossarySuggestionTableProps {
	suggestions: {
		proposal: SecodaAIProposalOut;
		data: SuggestGlossaryArg;
	}[];
	onRowClick: (
		row: SuggestGlossaryArg & IBaseModel,
		index: number,
		event: MouseEvent
	) => void;
}

export function GlossarySuggestionTable({
	suggestions,
	onRowClick,
}: GlossarySuggestionTableProps) {
	const theme = useMantineTheme();
	const records = useMemo(
		() =>
			suggestions.map((suggestion) => ({
				...suggestion.data,
				id: suggestion.proposal.id,
				created_at: suggestion.proposal.created_at,
				updated_at: suggestion.proposal.updated_at,
			})),
		[suggestions]
	);

	return (
		<SuggestionItemTable<GlossarySuggestionWithBaseModel>
			items={records}
			iconRenderer={(item) => (
				<IconEmoji
					value={item.emoji || '📚'}
					size={theme.other.typography.text.md}
				/>
			)}
			titleSelector={(item) => item.term}
			subTextSelector={() => 'Create glossary term'}
			onItemClick={onRowClick}
		/>
	);
}
